
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import Button from '../base/Button';

const Header = () => {
  const { user, logout } = useAuth();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const navigation = [
    { name: 'Home', href: '/' },
    { name: 'Dashboard', href: '/dashboard' },
    { name: 'Trading', href: '/trading' },
    { name: 'Wallet', href: '/wallet' },
    { name: 'Analytics', href: '/analytics' },
    { name: 'Convert', href: '/convert' },
  ];

  const handleMobileMenuToggle = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <header className="bg-white shadow-sm border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center">
            <Link to="/" className="flex items-center space-x-2">
              <div className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center">
                <i className="ri-currency-line text-white text-lg"></i>
              </div>
              <span className="text-xl font-bold text-gray-900" style={{ fontFamily: '"Pacifico", serif' }}>
                CryptoTrade Pro
              </span>
            </Link>
          </div>

          <nav className="hidden md:flex items-center space-x-8">
            {user ? (
              <>
                <Link to="/dashboard" className="text-gray-700 hover:text-blue-600 font-medium">
                  Dashboard
                </Link>
                <Link to="/trading" className="text-gray-700 hover:text-blue-600 font-medium">
                  Trading
                </Link>
                <Link to="/wallet" className="text-gray-700 hover:text-blue-600 font-medium">
                  Wallet
                </Link>
                <Link to="/analytics" className="text-gray-700 hover:text-blue-600 font-medium">
                  Analytics
                </Link>
                <Link to="/convert" className="text-gray-700 hover:text-blue-600 font-medium">
                  Convert
                </Link>
                <div className="relative">
                  <button
                    onClick={() => setIsMenuOpen(!isMenuOpen)}
                    className="flex items-center space-x-2 text-gray-700 hover:text-blue-600 cursor-pointer"
                  >
                    <i className="ri-user-line"></i>
                    <span>{user.name}</span>
                    <i className="ri-arrow-down-s-line"></i>
                  </button>
                  {isMenuOpen && (
                    <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-200 py-2 z-50">
                      <Link to="/profile" className="block px-4 py-2 text-gray-700 hover:bg-gray-50">
                        Profile Settings
                      </Link>
                      <Link to="/security" className="block px-4 py-2 text-gray-700 hover:bg-gray-50">
                        Security
                      </Link>
                      <hr className="my-2" />
                      <button
                        onClick={logout}
                        className="block w-full text-left px-4 py-2 text-red-600 hover:bg-gray-50 cursor-pointer"
                      >
                        Logout
                      </button>
                    </div>
                  )}
                </div>
              </>
            ) : (
              <div className="flex items-center space-x-4">
                <Link to="/login" className="text-gray-700 hover:text-blue-600 font-medium">
                  Login
                </Link>
                <Link to="/register">
                  <Button>Get Started</Button>
                </Link>
              </div>
            )}
          </nav>

          <button 
            className="md:hidden cursor-pointer p-2"
            onClick={handleMobileMenuToggle}
          >
            <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl text-gray-700`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden border-t border-gray-200 py-4">
            {user ? (
              <div className="space-y-4">
                <div className="flex items-center space-x-3 px-4 py-2 border-b border-gray-100">
                  <i className="ri-user-line text-gray-600"></i>
                  <span className="font-medium text-gray-900">{user.name}</span>
                </div>
                <Link 
                  to="/dashboard" 
                  className="block px-4 py-2 text-gray-700 hover:text-blue-600 hover:bg-gray-50"
                  onClick={closeMobileMenu}
                >
                  Dashboard
                </Link>
                <Link 
                  to="/trading" 
                  className="block px-4 py-2 text-gray-700 hover:text-blue-600 hover:bg-gray-50"
                  onClick={closeMobileMenu}
                >
                  Trading
                </Link>
                <Link 
                  to="/wallet" 
                  className="block px-4 py-2 text-gray-700 hover:text-blue-600 hover:bg-gray-50"
                  onClick={closeMobileMenu}
                >
                  Wallet
                </Link>
                <Link 
                  to="/analytics" 
                  className="block px-4 py-2 text-gray-700 hover:text-blue-600 hover:bg-gray-50"
                  onClick={closeMobileMenu}
                >
                  Analytics
                </Link>
                <Link 
                  to="/convert" 
                  className="block px-4 py-2 text-gray-700 hover:text-blue-600 hover:bg-gray-50"
                  onClick={closeMobileMenu}
                >
                  Convert
                </Link>
                <div className="border-t border-gray-200 pt-4">
                  <Link 
                    to="/profile" 
                    className="block px-4 py-2 text-gray-700 hover:bg-gray-50"
                    onClick={closeMobileMenu}
                  >
                    Profile Settings
                  </Link>
                  <Link 
                    to="/security" 
                    className="block px-4 py-2 text-gray-700 hover:bg-gray-50"
                    onClick={closeMobileMenu}
                  >
                    Security
                  </Link>
                  <button
                    onClick={() => {
                      logout();
                      closeMobileMenu();
                    }}
                    className="block w-full text-left px-4 py-2 text-red-600 hover:bg-gray-50 cursor-pointer"
                  >
                    Logout
                  </button>
                </div>
              </div>
            ) : (
              <div className="space-y-4">
                <Link 
                  to="/" 
                  className="block px-4 py-2 text-gray-700 hover:text-blue-600 hover:bg-gray-50"
                  onClick={closeMobileMenu}
                >
                  Home
                </Link>
                <Link 
                  to="/login" 
                  className="block px-4 py-2 text-gray-700 hover:text-blue-600 hover:bg-gray-50"
                  onClick={closeMobileMenu}
                >
                  Login
                </Link>
                <Link 
                  to="/register" 
                  className="block px-4 py-2 text-blue-600 font-medium hover:bg-gray-50"
                  onClick={closeMobileMenu}
                >
                  Get Started
                </Link>
              </div>
            )}
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
